(function () {
	"use strict";

	angular
		.module("app")
		.service("reportService", service);

	function service($http) {
		const self = this;		

        const ie = navigator.userAgent.match(/Edge|\.NET|MSIE/g);

	    self.getProductUtilizationSearch = (searchRequest) => {
	        return $http
	            .post(`api/reports/product-utilization-report`, searchRequest)
	            .then(res => res.data);
	    };

	    self.getCertificateOfAnalysisRpt = lotNo => {
	        const popup = createPopup(`Certificate Of Analysis - ${lotNo}`);

	        return $http.get(`/api/reports/certificate-of-analysis-report/${lotNo}`,
	                { responseType: "arraybuffer" } /*This is important to open the pdf*/)
	            .then(result => openReport(result.data, `${lotNo}.pdf`, popup))
	            .catch(err => handleError(popup, err));
        };

        self.getQuarterlyRpts = () => {
	        return $http
                .get(`api/reports/quarterly`)
	            .then(res => res.data);
	    };

	    self.getQuarterlyRpt = report => {
            const popup = createPopup(`Quarterly - ${report.the_quarter}`);

            return $http.get(`/api/reports/quarterly/${report.the_quarter}`,
	                { responseType: "arraybuffer" } /*This is important to open the pdf*/)
	            .then(result => openReport(result.data, `${report.upd_file_name}`, popup))
	            .catch(err => handleError(popup, err));
	    };

	    self.getPackListRpt = orderId => {
	        const popup = createPopup(`Pack List - ${orderId}`);

	        return $http.get(`/api/reports/pack-list/${orderId}`,
	                { responseType: "arraybuffer" } /*This is important to open the pdf*/)
	            .then(result => openReport(result.data, `${orderId}.pdf`, popup))
	            .catch(err => handleError(popup, err));
	    };

	    self.getInvoiceRpt = orderId => {
	        const popup = createPopup(`Invoice - ${orderId}`);

	        return $http.get(`/api/reports/invoice/${orderId}`,
	                { responseType: "arraybuffer" } /*This is important to open the pdf*/)
	            .then(result => openReport(result.data, `${orderId}.pdf`, popup))
	            .catch(err => handleError(popup, err));
	    };

	    self.getE222Form = orderId => {
	        const popup = createPopup(`Invoice - ${orderId}`);

	        return $http.get(`/api/reports/e222Form/${orderId}`,
	                { responseType: "arraybuffer" } /*This is important to open the pdf*/)
	            .then(result => openReport(result.data, `${orderId}.pdf`, popup))
	            .catch(err => handleError(popup, err));
	    };

        function createPopup(title) {
            let popup = undefined;
            if (!ie) {
                popup = window.open("", title);
                popup.document.body.append(popup.document.createElement('div').innerHtml = 'Loading...');
            }
            return popup;
        }

        function openReport(data, filename, popup) {
            const file = new Blob([data], { type: "application/pdf" });
            const fileUrl = URL.createObjectURL(file);
  
            if (ie) {
                window.navigator.msSaveBlob(file, filename);
            } else {
                popup.location.href = fileUrl;
            }
        } 

        function handleError(popup, err) {
            if (popup) popup.close();
            throw err;
        }
	}
	service.$inject = ["$http"];

})()